/* eslint-disable no-console */
import {Col, Row} from 'antd';
import React from 'react';

import BoxContent from '../../../../components/BoxContent/BoxContent';
import CarouselComp from '../../../../components/Carousel/CarouselComp';
import InformativeText from '../../../../constants/InformativeText';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {convertPxToRem} from '../../../../utils/commonFunctions';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';
import AllFacilityDisplay from '../../components/AllFacilityDisplay';
import TotalChartList from '../../components/TotalChartList';
import ValueRepresentationBox from '../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../constants/commonConstants';

const EnergyAndUtilities: React.FC<{data: any[]}> = ({data}) => {
  const generalizedInformative = InformativeText?.NZM?.generalized;
  const smallCol = 9;
  const bigCol = 24 - smallCol;
  const carouselContent = [
    {
      content: (
        <TotalChartList
          data={data}
          keyArray={[
            'Energy consumption',
            'Energy consumption outside organization',
            'Energy consumption inside organization'
          ]}
          showTotal={false}
          chartType="progress"
          tooltip={generalizedInformative.Energy_consumption}
          noBackground={true}
          labelType="flex"
          isLabelValue={true}
          convertToTJ={true}
        />
      )
    },
    {
      content: (
        <TotalChartList
          data={data}
          keyArray={[
            'Energy consumption inside organization',
            'Renewable Energy consumption',
            'Non-Renewable Energy consumption'
          ]}
          showTotal={false}
          chartType="progress"
          noBackground={true}
          labelType="flex"
          isLabelValue={true}
          tooltip={generalizedInformative.Energy_consumption}
          convertToTJ={true}
        />
      )
    }
  ];

  return (
    <>
      <Row className="energyUtilityMainFlex" gutter={rowGutterNZM}>
        <Col span={smallCol}>
          <Row gutter={rowGutterNZM}>
            <Col span={24} style={{height: convertPxToRem(366)}}>
              <BoxContent>
                <CarouselComp
                  data={carouselContent}
                  showArrows={true}
                  type="graph"
                  draggable={true}
                  infinite={false}
                  effect="scrollx"
                  fade={true}
                  easing="ease-in-out"
                />
              </BoxContent>
            </Col>
            <Col span={24} style={{height: convertPxToRem(318)}}>
              <TotalChartList
                data={data}
                keyArray={[
                  'Energy intensity',
                  'Renewable Energy intensity',
                  'Non-Renewable Energy intensity'
                ]}
                chartType="pie"
                tooltip={generalizedInformative.Energy_intensity}
                convertToTJ={true}
              />
            </Col>
          </Row>
        </Col>
        <Col span={bigCol}>
          {/* <Row typeof="flex" style={{height: '100%'}} gutter={rowGutterNZM}> */}
          {/* <Col span={24} style={{height: '100%'}}> */}
          <AllFacilityDisplay
            data={data}
            keyArray={['All Facilities']}
            convertToTJ={true}
          />
          {/* </Col> */}
          {/* </Row> */}
        </Col>
      </Row>
      <Row
        typeof="flex"
        style={{height: convertPxToRem(318)}}
        gutter={rowGutterNZM}
      >
        <Col span={smallCol}>
          <TotalChartList
            data={data}
            keyArray={[
              'Total Fuel consumption',
              'Renewable fuel consumption',
              'Non-Renewable Fuel consumption'
            ]}
            chartType="pie"
            tooltip={generalizedInformative.Fuel_and_related_activities}
          />
        </Col>
        <Col span={smallCol}>
          <TotalChartList
            data={data}
            keyArray={[
              'Total electricity consumption',
              'Renewable Electricity consumption',
              'Non-Renewable Electricity consumption'
            ]}
            chartType="pie"
          />
        </Col>
        <Col span={24 - smallCol * 2}>
          <ValueRepresentationBox
            data={data}
            mainKey="Fuel And Related Activities"
            tooltip={generalizedInformative.Fuel_and_related_activities}
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(433)}}>
        <Col span={12}>
          <TotalChartList
            chartType="bar"
            showTotal={false}
            keyArray={['Highest Sources Of Water Consumption']}
            data={data}
            dataInMainData={true}
            showChartList={false}
            tooltip={
              generalizedInformative.Highest_sources_of_water_consumption
            }
          />
        </Col>
        <Col span={12}>
          <TotalChartList
            chartType="bar"
            showTotal={false}
            keyArray={['Most Type Of Waste Generated']}
            data={data}
            dataInMainData={true}
            showChartList={false}
            tooltip={generalizedInformative.Most_type_of_waste}
            isBlock={shouldBlockModuleAccess(accessModule.scope3)}
          />
        </Col>
      </Row>
    </>
  );
};

export default EnergyAndUtilities;
